declare namespace $ {

	type $shm_button_open__title_shm_hitalama_attach_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_attach['attach_title'] >
		,
		ReturnType< $shm_button_open['title'] >
	>
	type $shm_button_open__files_shm_hitalama_attach_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_attach['attach_new'] >
		,
		ReturnType< $shm_button_open['files'] >
	>
	export class $shm_hitalama_attach extends $mol_attach {
		files( next?: readonly(File)[] ): readonly(File)[]
		Add( ): $shm_button_open
	}
	
}

//# sourceMappingURL=attach.view.tree.d.ts.map